module.exports = __webpack_public_path__ + "static/media/banner2.f7f924cd.jpeg";